<template>
  <div class="selectCustomerCategory">
    <v-select
      v-model="inputedValue"
      item-text="label"
      item-value="value"
      :items="createCustomerCategorySelectBoxValueFrom()"
      dense
      outlined
      class="original-selectbox"
      hide-details
      :placeholder="$t('common.input_unselected_2')"
      :height="height"
      :clearable="true"
    >
    </v-select>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
export default {
  props: {
    value: {
      type: Number,
      require: true
    },
    height: { default: '32px' }
  },
  data: () => ({
    customerCategories: []
  }),
  computed: {
    inputedValue: {
      get() {
        return this.value
      },
      set(newValue) {
        if (!newValue) {
          newValue = undefined
        }

        this.$emit('input', newValue)
      }
    }
  },
  created() {
    this.getCustomerCategoryList()
  },
  methods: {
    ...mapActions('Common', ['getCustomerCategoryListFromApi']),
    ...mapGetters('Common', ['getCustomerCategoryFromState']),
    async getCustomerCategoryList() {
      await this.getCustomerCategoryListFromApi()
      this.customerCategories = this.getCustomerCategoryFromState()
    },
    createCustomerCategorySelectBoxValueFrom() {
      if (!this.customerCategories) {
        return
      }
      const result = []
      this.customerCategories.forEach((ele) => {
        result.push({
          value: ele.customerCategoryId,
          label: ele.name
        })
      })
      return result
    }
  }
}
</script>
<style scoped lang="scss">
.selectCurrencyStyle {
  width: 100%;
}
</style>
